import { useEffect, useState } from "react";

const KEY = "rax_cookie_consent_v1";

export default function CookieBanner() {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        try {
            if (!localStorage.getItem(KEY)) setVisible(true);
        } catch {
            /* noop */
        }
    }, []);

    const decide = (val) => {
        try {
            localStorage.setItem(KEY, val);
        } catch {
            /* noop */
        }
        setVisible(false);
    };

    if (!visible) return null;

    return (
        <div className="cookie-banner" role="dialog" aria-label="Cookie consent" data-testid="cookie-banner">
            <p>
                We use a light touch of cookies for site analytics — no ad tracking, no third-party selling.{" "}
                <a href="/legal/cookies" style={{ textDecoration: "underline" }}>
                    Details
                </a>
                .
            </p>
            <div className="cookie-banner-actions">
                <button className="btn btn-outline" onClick={() => decide("decline")} data-testid="cookie-decline" style={{ borderColor: "var(--ivory)", color: "var(--ivory)" }}>
                    Decline
                </button>
                <button className="btn btn-ivory" onClick={() => decide("accept")} data-testid="cookie-accept">
                    Accept
                </button>
            </div>
        </div>
    );
}
